module.exports = __webpack_public_path__ + "img/ScubaTank.da944434.svg";